module.exports = __webpack_public_path__ + "img/DE01442.04c9419a.png";